export default "__VITE_ASSET__CLO968Jh__"